<template>
  <div class="context-bar-and-content">
    <div class="application">
      <div class="application-header">
        <slot name="context-bar-full">
          <div class="left">
            <slot name="context-bar-left"></slot>
          </div>
          <div class="middle">
            <slot name="context-bar-middle"></slot>
          </div>
          <div class="right">
            <slot name="context-bar-right"></slot>
          </div>
        </slot>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="application-footer" v-if="displayFooter">
        <div class="left">
          <slot name="footer-left"></slot>
        </div>
        <div class="middle">
          <slot name="footer-middle"></slot>
        </div>
        <div class="right">
          <slot name="footer-right"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'context-bar-and-content',
  props: {
    displayFooter: {
      type: Boolean,
      default: true,
    },
  },
};

</script>

<style lang="scss">

.context-bar-and-content {
  height: calc(100% + 36px);
  margin: -18px;

  .application {
    display: flex;
    flex-direction: column;
    height: 100%;

    .application-header, .content, .application-footer {
      display: flex;
      padding: 0 18px;
      align-content: center;
      align-items: center;
    }

    .application-header, .application-footer {
      height: 60px;
      background: #F2F2F2;
      .left, .right {
        flex: 0 0 auto;
      }
      .middle {
        align-content: center;
        flex: 1;
        text-align: center;
      }
    }

    .content {
      min-width: 0;
      flex: 1;
      flex-direction: column;
      min-height: 0;
      max-height: 100%;
      overflow-y: auto;
      padding: 0;
    }
  }
}

</style>
